var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { inputOtpConfig, tokens } from '../../constants';
import { BLUE_500 } from '../../constants/colors';
var getInputOtpWrapperStyles = props => {
  var _a, _b, _c, _d;
  var _state = props.state,
    _isDisabled = props.isDisabled,
    pressableStates = props.pressableStates,
    config = props.config;
  var hovered = pressableStates.hovered,
    focused = pressableStates.focused;
  var states = config.states;
  var isDisabled = _isDisabled || _state === 'disabled';
  var state = _state;
  state = isDisabled ? 'disabled' : state;
  var isHoverState = !isDisabled && (hovered || state === 'hover');
  var stateProps = states === null || states === void 0 ? void 0 : states[state];
  var backgroundColor = (stateProps === null || stateProps === void 0 ? void 0 : stateProps.backgroundColor) || ((_a = states === null || states === void 0 ? void 0 : states.none) === null || _a === void 0 ? void 0 : _a.backgroundColor);
  var borderColor = (stateProps === null || stateProps === void 0 ? void 0 : stateProps.borderColor) || ((_b = states === null || states === void 0 ? void 0 : states.none) === null || _b === void 0 ? void 0 : _b.borderColor);
  var spacing = tokens.spacing;
  if (state === 'none' && focused) borderColor = (_c = states === null || states === void 0 ? void 0 : states.focused) === null || _c === void 0 ? void 0 : _c.borderColor;
  var borderRadius = tokens.borderRadius.BORDER_RADIUS_8;
  if (state === 'none' && focused) borderColor = (_d = states === null || states === void 0 ? void 0 : states.focused) === null || _d === void 0 ? void 0 : _d.borderColor;
  return {
    marginVertical: spacing.SPACING_12,
    flexDirection: 'row',
    borderWidth: isHoverState ? spacing.SPACING_2 : spacing.SPACING_1,
    paddingVertical: isHoverState ? spacing.SPACING_5 : spacing.SPACING_6,
    borderRadius,
    backgroundColor,
    borderColor,
    width: 42,
    height: 52,
    alignItems: 'center',
    justifyContent: 'center'
  };
};
export var getTextInputOtpStyles = props => {
  var _a, _b;
  var state = props.state,
    _isDisabled = props.isDisabled,
    config = props.config;
  var isDisabled = _isDisabled || state === 'disabled';
  var _state = isDisabled || state === 'disabled' ? 'disabled' : 'none';
  var color = ((_b = (_a = config === null || config === void 0 ? void 0 : config.states) === null || _a === void 0 ? void 0 : _a[_state]) === null || _b === void 0 ? void 0 : _b.inputTextColor) || config.states.none.inputTextColor;
  return StyleSheet.create({
    otpTextStyle: {
      maxWidth: 42,
      textAlign: 'center',
      flexGrow: 1,
      color,
      padding: 0
    },
    hiddenInput: {
      position: 'absolute',
      color: 'transparent',
      width: '100%',
      height: 52,
      alignSelf: 'center'
    }
  });
};
export var getOtpBoxesStyles = (props, pressableStates) => {
  var _a, _b, _c, _d;
  var _props$config = props.config,
    config = _props$config === void 0 ? {} : _props$config,
    state = props.state;
  var stateColor = ((_b = (_a = config === null || config === void 0 ? void 0 : config.states) === null || _a === void 0 ? void 0 : _a[state]) === null || _b === void 0 ? void 0 : _b.borderColor) || BLUE_500;
  if (state === 'none' && (pressableStates === null || pressableStates === void 0 ? void 0 : pressableStates.focused)) {
    stateColor = (_d = (_c = config === null || config === void 0 ? void 0 : config.states) === null || _c === void 0 ? void 0 : _c.focused) === null || _d === void 0 ? void 0 : _d.borderColor;
  }
  return StyleSheet.create({
    inputOtpWrapper: getInputOtpWrapperStyles(Object.assign(Object.assign({}, props), {
      config,
      pressableStates
    })),
    cursorColor: {
      backgroundColor: stateColor
    }
  });
};
var getLabelStyles = props => {
  var config = props.config;
  return {
    color: config.states.none.labelColor
  };
};
var getHintStyles = props => {
  var _a, _b, _c, _d;
  var state = props.state,
    useStateHintColor = props.useStateHintColor,
    config = props.config,
    isActionableHint = props.isActionableHint;
  var noneHintColor = (_b = (_a = config === null || config === void 0 ? void 0 : config.states) === null || _a === void 0 ? void 0 : _a.none) === null || _b === void 0 ? void 0 : _b.hintColor;
  var color = useStateHintColor && ((_d = (_c = config.states) === null || _c === void 0 ? void 0 : _c[state]) === null || _d === void 0 ? void 0 : _d.hintColor) || noneHintColor;
  if (isActionableHint) color = BLUE_500;
  return {
    color
  };
};
export var getInputOtpStyles = props => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    container: {
      alignItems: 'center'
    },
    label: getLabelStyles(props),
    otpBoxesContainer: {
      flexDirection: 'row'
    },
    hintContainer: {
      minHeight: spacing.SPACING_18
    },
    hint: getHintStyles(props)
  });
};
export var getInputOtpProps = (props, context) => {
  var _a, _b;
  var theme = props.theme || context.theme;
  var configProps = merge(inputOtpConfig === null || inputOtpConfig === void 0 ? void 0 : inputOtpConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.inputOtp) === null || _a === void 0 ? void 0 : _a[theme]);
  var config = configProps.config,
    restConfigProps = __rest(configProps, ["config"]);
  var _state = (props === null || props === void 0 ? void 0 : props.state) || (configProps === null || configProps === void 0 ? void 0 : configProps.state);
  var isDisabled = (props === null || props === void 0 ? void 0 : props.theme) || (configProps === null || configProps === void 0 ? void 0 : configProps.isDisabled);
  var state = isDisabled || _state === 'disabled' ? 'disabled' : 'none';
  return Object.assign(Object.assign(Object.assign({
    theme,
    config
  }, restConfigProps), props), {
    placeholderTextColor: (_b = config.states) === null || _b === void 0 ? void 0 : _b[state].placeholderColor
  });
};